/**
 * flags.js — Mapping de banderas de selecciones nacionales para el Mundial 2026
 * Ahora utilizando FlagCDN para máxima compatibilidad y calidad visual.
 */

export const TEAM_FLAGS = {
  // Grupo A
  'México': 'mx', 'Sudáfrica': 'za', 'República de Corea': 'kr', 'Chequia': 'cz',
  // Grupo B
  'Canadá': 'ca', 'Bosnia y Herzegovina': 'ba', 'Catar': 'qa', 'Suiza': 'ch',
  // Grupo C
  'Brasil': 'br', 'Marruecos': 'ma', 'Haití': 'ht', 'Escocia': 'gb-sct',
  // Grupo D
  'Australia': 'au', 'Turquía': 'tr', 'EE. UU.': 'us', 'Paraguay': 'py',
  // Grupo E
  'Alemania': 'de', 'Curazao': 'cw', 'Costa de Marfil': 'ci', 'Ecuador': 'ec',
  // Grupo F
  'Países Bajos': 'nl', 'Japón': 'jp', 'Suecia': 'se', 'Túnez': 'tn',
  // Grupo G
  'Bélgica': 'be', 'RI de Irán': 'ir', 'Nueva Zelanda': 'nz', 'Egipto': 'eg',
  // Grupo H
  'España': 'es', 'Uruguay': 'uy', 'Arabia Saudí': 'sa', 'Islas de Cabo Verde': 'cv',
  // Grupo I
  'Francia': 'fr', 'Irak': 'iq', 'Noruega': 'no', 'Senegal': 'sn',
  // Grupo J
  'Argentina': 'ar', 'Austria': 'at', 'Jordania': 'jo', 'Argelia': 'dz',
  // Grupo K
  'Portugal': 'pt', 'Uzbekistán': 'uz', 'Colombia': 'co', 'RD Congo': 'cd',
  // Grupo L
  'Inglaterra': 'gb-eng', 'Ghana': 'gh', 'Panamá': 'pa', 'Croacia': 'hr',
};

/**
 * Retorna el HTML para la bandera de un equipo.
 */
export function getFlagHtml(team) {
  if (!team) return '';

  const normalizedTeam = String(team).trim().normalize('NFC');
  const code = TEAM_FLAGS[normalizedTeam];
  
  if (!code) {
    return `<span class="flag-icon flag-icon--fallback" style="font-size:1rem; display:inline-block; vertical-align:middle; margin:0 0.2rem;">🚩</span>`;
  }

  // Usamos FlagCDN para SVGs de alta calidad (más nítidos y escalables)
  const url = `https://flagcdn.com/${code.toLowerCase()}.svg`;
  
  return `<img 
    src="${url}" 
    alt="Bandera de ${normalizedTeam}" 
    class="flag-icon flag-img" 
    loading="lazy"
    style="width: 20px; height: 15px; object-fit: cover; border-radius: 2px; box-shadow: 0 1px 2px rgba(0,0,0,0.15); display: inline-block; vertical-align: middle; margin: 0 0.4rem;"
  >`;
}
